
export const handlePaginationGeneral = (
  action,
  pagination,
  itemsPerPage,
  pagArray,
  setPagination,
  infiniteLoop = false,
) => {
  const factor = pagArray.length / itemsPerPage;

  if (pagination + action * itemsPerPage < 0) {
    if (Number.isInteger(factor) && infiniteLoop)
      return setPagination(pagArray.length - itemsPerPage);
    else {
      if (pagination === 0 && infiniteLoop) {
        setPagination(
          pagArray.length - Math.round(pagArray.length % itemsPerPage),
        );
      } else setPagination(0);
    }
  } else if (pagination + action * itemsPerPage >= pagArray.length) {
    return setPagination(prevState => {
      return infiniteLoop ? 0 : prevState;
    });
  } else {
    return setPagination(pagination + action * itemsPerPage);
  }
};
